import { cn } from '@/lib/tailwind.utils'
import { AdaptationCycleBaseConfig } from '../types'
import HomeContent from '../../../../src/components/SectionContent'

interface AdaptationCyclePageHeaderProps {
  adaptationCycle: AdaptationCycleBaseConfig
  className?: string
  children?: React.ReactNode
}

export const AdaptationCycleHeader = ({
  adaptationCycle,
  className,
  children,
}: AdaptationCyclePageHeaderProps) => {
  const { title, tagline, description, heroImage } = adaptationCycle

  return (
    <div className={cn('py-6 md:py-12', className)}>
      <HomeContent>
        <div className="flex gap-8">
          <div className="flex items gap-8 w-1/2 flex-col">
            <div>
              <span className="text-paragraph tracking-widest uppercase">Adaptation Cycle</span>
              <h2 className={cn('text-[30px] font-semibold text-primary')}>{title}</h2>
              <p className="text-paragraph">{tagline}</p>
            </div>
            <p className="text-paragraph">{description}</p>
            <div className="border-b border-b-border border-solid w-full" />
            {children}
          </div>
          <div>
            <img alt="four stages of the adaptation cycle" src={heroImage} />
          </div>
        </div>
      </HomeContent>
    </div>
  )
}
